import SmartLabel from "@/domain/enums/SmartLabel";

type RepartitionDataProps = {
    id: SmartLabel;
    value: number;
};

export default class RepartitionData {
    id: SmartLabel;

    value: number;

    constructor({ id, value }: RepartitionDataProps) {
        this.id = id;
        this.value = value;
    }
}
